export const NAME = 'bandingMachines';